<template>
  <section class="content-ebook-register">
    <Breadcrumb :links="links" :data="{name: 'Ebook', id: ebookParams.id}"/>
    <form class="content-ebook-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input type="text" name="name" v-model="ebook.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedCategory && selectedCategory !== ''}">
            <select v-model="selectedCategory" required>
              <option value="" selected disabled>Selecione a categoria</option>
              <option v-for="category in ebooksCategories" :key="category.id" :value="category.id">{{ category.name }}</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <quill-editor v-model="ebook.contentHtml" ref="refQuillEditor" :options="quillOptions"></quill-editor>
          </div>
        </div>
        <div class="col-12">
          <div class="content-datasheet">
            <div class="content-datasheet--header">
              <h2>Ficha Técnica</h2>
            </div>
            <div class="content-datasheet-body">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="content-input-default">
                    <input type="text" name="author" v-model="ebook.author" value="" placeholder="Author" required/>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="content-input-default">
                    <input type="text" name="gender" v-model="ebook.gender" value="" placeholder="Gênero" required/>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="content-input-default">
                    <input type="text" name="publishing-company" v-model="ebook.publishing_company" value="" placeholder="Editora"/>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="content-input-default">
                    <input type="text" name="year" v-model="ebook.year" value="" placeholder="Ano" required/>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="content-input-default">
                    <input type="text" name="edition" v-model="ebook.edition" value="" placeholder="Edição"/>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="content-input-default">
                    <input type="text" name="language" v-model="ebook.language" value="" placeholder="Idioma" required/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <UploadImage @changePicture="(value) => ebook.picture = value"/>
        </div>
        <div class="col-12">
          <UploadEbook @changeFile="(name, url) => (ebook.file_name = name, ebook.file = url)"/>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import UploadImage from '@/components/upload/Index';
import UploadEbook from '@/views/Ebooks/components/UploadEbook';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Ebooks',
          routerName: 'Ebooks'
        },
        {
          name: 'Novo Ebook',
          routerName: 'RegisterEbooks'
        },
      ],
      ebook: {
        id_user: "",
        name: '',
        contentHtml: '',
        author: '',
        gender: '',
        publishing_company: '',
        year: '',
        edition: '',
        language: '',
        picture: null,
        file: null,
        file_name: '',
      },
      quillOptions: {
        placeholder: 'Descreva as informações completa sobre o ebook',
        readonly: false,
      },
      selectedCategory: '',
      ebookParams: this.$route.params
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/user',
      ebookData: 'Ebooks/ebook',
      ebooksCategories: 'Ebooks/ebooksCategories'
    })
  },
  components: {
    Breadcrumb,
    UploadImage,
    UploadEbook
  },
  methods: {
    ...mapActions('Ebooks', ['consultCategoriesEbooks', 'registerEbook', 'consultEbooks']),
    ...mapActions(['setImageFileUrl', 'setFile']),
    async handleSubmit(){
      let message = this.ebook?.id ? 'Ebook editado com sucesso!' : 'Ebook cadastrado com sucesso!';

      this.ebook.id_ebook_category = this.selectedCategory;

      await this.registerEbook(this.ebook);
      this.$router.push({ name: 'Ebooks' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    this.consultCategoriesEbooks();
    this.ebook.id_user = await this.user.id;
    this.setImageFileUrl(null);
    this.setFile(null);
    if (this.ebookParams && Object.keys(this.ebookParams).length > 0) {
      await this.consultEbooks(this.ebookParams);
      this.ebook = this.ebookData;
      this.selectedCategory = this.ebook.id_ebook_category;
      this.links[1].name = this.ebook.name;
      this.setImageFileUrl(this.ebook.picture);
      let obj = { name: this.ebook.file_name, url: this.ebook.file };
      this.setFile(obj);
    }
  }
}
</script>

<style lang="scss" scoped>
.content-ebook-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.content-datasheet {
  margin: 20px 0px;
  &--header {
    text-align: left;
    margin-bottom: 30px;
    h2 {
      font-size: 16px;
      font-family: 'Font Semibold';
      color: var(--black);
      margin-bottom: 0;
    }
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
